import { Area } from './area';
import { ControlOptions } from '../control';
import { SignalIdentifier } from '../signal-identifier';
import { SimpleControl } from '../simple-control';

export class BooleanSignal extends SimpleControl {
  readonly: boolean;
  standalone: boolean;
  signalId: SignalIdentifier;
  areas: Area[];

  readonly minimumHeight = 2.5;

  get minimumWidth() {
    return this.readonly ? 2.5 : 7.5;
  }

  readonly humanReadableName = 'Boolean Signal';

  constructor({
    readonly = false,
    standalone = true,
    signalId = new SignalIdentifier(),
    areas = [],
    ...options
  }: BooleanSignalOptions) {
    super(options);

    this.readonly = readonly;
    this.standalone = standalone;
    this.signalId = signalId;
    this.areas = areas;
  }
}

export interface BooleanSignalOptions extends ControlOptions {
  readonly?: boolean;
  standalone?: boolean;
  signalId?: SignalIdentifier;
  // Boolean Signals does not have any areas, this is for smooth conversion between signal control types.
  areas?: Area[];
}
